module.exports = __webpack_public_path__ + "static/media/video_depressed_small.fbf3af2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/video_depressed_small.mp4
// module id = AGha
// module chunks = 1